// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceAndPricePromise_container__t20gZ","wrapOnMobile":"PriceAndPricePromise_wrapOnMobile__T5_Zy"};